import { Eyebrow, Reveal } from "@/components/Reveal";
import RouteMap from "@/components/RouteMap";

export default function CoverageArea() {
  return (
    <section id="coverage" data-testid="coverage-section" className="relative py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid grid-cols-1 items-center gap-14 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <Reveal>
              <Eyebrow>Coverage area</Eyebrow>
              <h2 className="font-display mt-4 text-4xl font-extrabold uppercase leading-[0.95] tracking-tight text-[#F6F1E3] sm:text-6xl">
                One route.<br />
                <span className="text-outline-gold">Ridden hard.</span>
              </h2>
              <p className="mt-7 max-w-md text-base leading-relaxed text-[#B9C4B4] sm:text-lg">
                From Canberra and Queanbeyan down the Monaro — Michelago, Bredbo,
                Cooma, Berridale — to Jindabyne and the lake towns. Canberra
                pickups 7 days; same-day or next-day depending on pickup
                availability.
              </p>
            </Reveal>
            <Reveal delay={0.15}>
              <div className="mt-10 rounded-2xl border border-[#F0A829]/30 bg-[#122A1F]/70 p-6">
                <p className="font-mono-brand text-[10px] uppercase tracking-[0.3em] text-[#F0A829]">
                  Outside the route?
                </p>
                <p className="mt-3 text-sm leading-relaxed text-[#B9C4B4]">
                  If you&apos;re near the run — the Monaro, the Snowy Mountains,
                  or somewhere in between — give us a ring. We&apos;re kilted,
                  not limited.
                </p>
                <a
                  data-testid="coverage-call-button"
                  href="tel:+61408464106"
                  className="font-display mt-5 inline-block rounded-full border border-[#F0A829] px-6 py-3 text-sm font-bold uppercase tracking-wider text-[#F0A829] transition-colors duration-300 hover:bg-[#F0A829] hover:text-[#0C1F17]"
                >
                  Ask about your town
                </a>
              </div>
            </Reveal>
            <Reveal delay={0.2}>
              <p className="font-mono-brand mt-6 text-[10px] uppercase tracking-[0.25em] text-[#B9C4B4]">
                * Same-day or next-day depending on pickup availability
              </p>
            </Reveal>
          </div>

          <Reveal delay={0.1} className="lg:col-span-7">
            <RouteMap />
          </Reveal>
        </div>
      </div>
    </section>
  );
}
